import { useQuery } from '@tanstack/react-query'
import { api } from './api'
import { workspaceListResponse } from './types'

/**
 * Shared "my Workspaces" query. Reuses the existing `['workspaces','mine']`
 * cache key so every caller hits one cached entry (TanStack dedupes).
 *
 * Phase 1 of the Workspace de-emphasis: a company operating in a single
 * Workspace has nothing to switch between, so the Workspace switcher,
 * filters, nav item and "Workspace Name" columns are hidden for them.
 * `hasMultiple` is the one signal that drives all of that — when it's
 * false (0 or 1 Workspace, i.e. every new company), Workspace UI collapses
 * away; with 2+ Workspaces the full UI stays exactly as before.
 *
 * `isReady` guards against flicker: while the count is still loading we
 * don't want to flash the Workspace UI and then hide it (or vice-versa),
 * so callers can wait for `isReady` before deciding.
 */
export function useMyWorkspaces() {
  const query = useQuery({
    queryKey: ['workspaces', 'mine'],
    queryFn: async () => {
      const res = await api.get('/workspaces/mine')
      return workspaceListResponse.parse(res.data)
    },
  })
  const workspaces = query.data?.data ?? []
  return {
    workspaces,
    count: workspaces.length,
    hasMultiple: workspaces.length > 1,
    isReady: !query.isLoading,
    isLoading: query.isLoading,
  }
}
